import { connectAuthEmulator, getAuth } from "firebase/auth";
import app from "./firebase";

export const auth = getAuth(app);

if (process.env.REACT_APP_USE_EMULATORS === "true" && !globalThis.__yshalehAuthEmu) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  globalThis.__yshalehAuthEmu = true;
}
